import { registerArchetype } from './index.js';
import { getRuntimes } from '../combat.js';
registerArchetype({
    id: 'counter',
    apply: ({ state, source, params }) => {
        const chance = params.chance ?? 0.3;
        const multiplier = params.multiplier ?? 0.5;
        const r = getRuntimes(state, source.side)[source.slot];
        r.statuses.push({
            id: `counter_${source.slot}`,
            kind: 'buff',
            remainingTicks: Number.MAX_SAFE_INTEGER,
            params: { counterChance: chance, counterMult: multiplier }
        });
    }
});
